// src/components/CampaignModal.jsx
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Gift } from 'lucide-react';
import { CAMPAIGN, LOGO_URL } from '../data/mock';

const CampaignModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="
          bg-neutral-900 border-neutral-700 text-white
          w-[calc(100vw-2rem)] sm:w-full sm:max-w-md
          max-h-[85vh] overflow-hidden
          p-4 sm:p-6
          fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2
        "
      >
        {/* Üst kısım sabit (scroll'a girmesin) */}
        <DialogHeader className="space-y-4">
          <div className="flex justify-center">
            <div className="relative">
              <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-amber-500 shadow-lg shadow-amber-500/20">
                <img
                  src={LOGO_URL}
                  alt="Mr Sweet"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -top-1 -right-1 w-6 h-6 bg-amber-500 rounded-full flex items-center justify-center">
                <Gift className="w-4 h-4 text-neutral-900" />
              </div>
            </div>
          </div>

          {/* Küçük ekranda kayma olmasın diye w-full eklendi */}
          <DialogTitle className="w-full text-2xl font-bold text-center text-amber-400">
            {CAMPAIGN.title}
          </DialogTitle>
        </DialogHeader>

        {/* Orta içerik: çok uzarsa burada scroll olur (modal kaymaz) */}
        <div className="mt-4 space-y-3 text-sm text-neutral-300 overflow-y-auto pr-2 max-h-[45vh] sm:max-h-[50vh]">
          <ul className="space-y-1">
            <li>☕ <strong>Sufle + Çay:</strong> 160 TL</li>
            <li>🍰 <strong>Pasta + Çay:</strong> 200 TL</li>
            <li>☕ <strong>Sufle + Limonata:</strong> 190 TL</li>
            <li>🍰 <strong>Pasta + Limonata:</strong> 230 TL</li>
            <li>☕ <strong>Sufle + Türk Kahvesi:</strong> 190 TL</li>
            <li>🍰 <strong>Pasta + Türk Kahvesi:</strong> 230 TL</li>
            <li>☕ <strong>Sufle + Dünya Kahveleri:</strong> 210 TL</li>
            <li>🍰 <strong>Pasta + Dünya Kahveleri:</strong> 250 TL</li>
          </ul>

          <div className="pt-3 border-t border-neutral-700">
            <p className="font-semibold text-amber-400 mb-1">
              Kampanyaya Dahil Tatlılar
            </p>
            <p className="text-neutral-400 leading-relaxed">
              Malaga, Magnolia, Sweet Kavanoz, Çilekli / Çikolatalı / Meyveli /
              Frambuazlı Pasta, Fıstık Rüyası, Mozaik Pasta, Marlenka, Tiramisu,
              Profiterol, Snickers, Çilek Şöleni, Fıstık Şöleni, Lotus Çilek
            </p>
          </div>
        </div>

        {/* Alt kısım sabit dursun */}
        <div className="mt-6 flex justify-center">
          <Button
            onClick={onClose}
            className="bg-amber-500 hover:bg-amber-600 text-neutral-900 font-semibold px-8 py-2 transition-colors"
          >
            Menüye Git
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CampaignModal;